import { render } from "./RegisterCompany.vue?vue&type=template&id=f5be8f80&scoped=true&lang=html"
import script from "./RegisterCompany.vue?vue&type=script&lang=js"
export * from "./RegisterCompany.vue?vue&type=script&lang=js"

import "./RegisterCompany.vue?vue&type=style&index=0&id=f5be8f80&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-f5be8f80"

export default script